import styled from '@emotion/styled';
import noavatar from './static/img/noavatar.png';
import Gravatar from 'react-gravatar';
import { css } from '@emotion/react';
import { Colors, media } from '@utex/ui-kit';
interface AvatarProps {
  email?: string;
}

export const Avatar = styled('div')<AvatarProps>`
  position: relative;
  flex-shrink: 0;
  display: flex;
  width: 8em;
  height: 8em;
  padding: 0;
  font-size: 1rem;
  background-image: ${(props) => !props.email && `url(${noavatar})`};
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;

  @media ${media.phonablet} {
    font-size: 0.45rem;
  }

  ${(props) =>
    props.email &&
    css`
      &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.15) 0%,
            rgba(0, 0, 0, 0.15) 100%
          ),
          linear-gradient(0deg, #3187ee, #3187ee);
        border-radius: 50%;
      }
    `};
`;

export const Text = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3em;
  font-weight: 700;
  text-transform: uppercase;
  color: ${Colors.text.inverse};
`;

interface GravatarItemProps {
  email?: string;
}

export const GravatarItem = styled(Gravatar)<GravatarItemProps>`
  z-index: ${(props) => props.email && 1};
  width: 100%;
  height: 100%;
  font-size: 0;
  border-radius: 50%;
`;

export const locked = css`
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  margin: 0 !important;
`;
